/**
 * @file 任务帮助
 * @author gaoxunchen
 */

import _ from 'lodash';
import React from 'react';
import { Button } from '@tencent/spaui';
import Icon from '@tencent/od-icon';

const TaskHelp: React.FC = () => {
  return (
    <Button
      displayType="text"
      icon={<Icon name="explain-outlined"/>}
      onClick={() => window.open('https://doc.weixin.qq.com/doc/w3_ANMApgZ_ACcml3hpwk5Th0mmNWZXP')}
    >
      任务帮助
    </Button>
  );
};

export default TaskHelp;
